import { render } from "./entrustQuery.vue?vue&type=template&id=1f3e86bd&scoped=true&ts=true"
import script from "./entrustQuery.vue?vue&type=script&lang=ts"
export * from "./entrustQuery.vue?vue&type=script&lang=ts"

import "./entrustQuery.vue?vue&type=style&index=0&id=1f3e86bd&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3e86bd"]])

export default __exports__